import { EventType } from './event-type.interface';

export const HUMIDITY: EventType = {
  name: 'Humidity',
  description: 'When a humidity sensor is triggered',
  route: 'humidity',
  category: 'Sensors',
  icon: 'humidity',
  whitelist: [
    {
      proxy: 'contactsingle_humiditysensor_c4',
      events: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/humidity.type.ts